import { useSeo } from "@/hooks/useSeo";
import Hero from "./components/Hero";
import Story from "./components/Story";
import ServicesSection from "./components/ServicesSection";
import Bridal from "./components/Bridal";
import Works from "./components/Works";
import Campaign from "./components/Campaign";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import FinalCta from "./components/FinalCta";

export default function Home() {
  useSeo({
    title: "gülaYonar | Bursa Nilüfer Saç ve Güzellik Salonu",
    description:
      "Bursa Nilüfer Odunluk'ta butik saç ve güzellik salonu. Saç tasarımı, renklendirme, gelin hazırlığı, HydraFacial cilt bakımı ve G5 masajı. Randevu ve bilgi için WhatsApp'tan ulaşın.",
    path: "/",
  });

  return (
    <>
      <Hero />
      <Story />
      <ServicesSection />
      <Bridal />
      <Works />
      <Campaign />
      <Faq />
      <Contact />
      <FinalCta />
    </>
  );
}